import { Pipe, PipeTransform } from '@angular/core';
import { AccommodationRoomConfiguration } from 'src/app/shared/models/quotes/itinerary-items/accommodation/accommodationRoomConfiguration';

@Pipe({
  name: 'roomTypes',
  standalone: false,
})
export class RoomTypesPipe implements PipeTransform {
  transform(roomConfiguration: AccommodationRoomConfiguration[]): string {
    if (!roomConfiguration?.length) {
      return '';
    }

    return roomConfiguration.map((room) => room.RoomType).join(', ');
  }
}
